export const institutionEditor = {
  createHeader: 'Create Institution',
  updateHeader: 'Update Institution',
  name: 'Name',
  abbreviation: 'Abbreviation',
  reset: 'Reset',
  save: 'Save',
};
